/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable  no-restricted-globals */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import React, { useEffect, useState, useMemo } from 'react'
import { useDebouncedCallback } from 'use-debounce'
import { useSelector, useDispatch } from 'react-redux'
import MagnifyIcon from 'mdi-react/MagnifyIcon'
import { useTranslation } from 'react-i18next'
import {
  Card,
  CardBody,
  Col,
  Row,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from 'reactstrap'
import classnames from 'classnames'

import { CountInfo } from 'Stories/CountInfo/CountInfo.stories'

import {
  changeCuratorAutopay,
  getCurators,
  getSelectedCurator,
  getAutopayCurators,
} from 'Redux/actions/usersActions'
import { getSelectedCuratorStats } from 'Redux/actions/reviewsActions'
import { cancelPayout } from 'Redux/actions/payoutsActions'
import PayoutsTable from './PayoutsTable'
import Modal from './ConfirmationModal'
import CuratorInfoModal from './CuratorInfoModal'
import PayoutCancelModal from './PayoutCancelModal'
import PayoutAutopayOffModal from './PayoutAutopayOffModal'

const Users = ({
  handleLoginAs,
  getAwaitingPayouts,
  getPaidPayouts,
  totalBalance,
  payoutToCurator,
  sendRecipientCheckingNeeded,
  awaitingPayouts,
  paidPayouts,
  payoutCounters,
  getPayouts,
}) => {
  const { t } = useTranslation()

  const dispatch = useDispatch()

  const autopayCurators = useSelector(state => state.users.autopayCurators)

  const selectedCurator = useSelector(state => state.users.selectedCurator)
  const { addedToPlayListCurrPeriod, requestsReceivedCurrPeriod } = useSelector(
    state => state.reviews.selectedCuratorStats
  )
  const { totalAutopayCurators } = useSelector(state => state.users.usersCount)

  const [activeTab, setActiveTab] = useState('1')
  const [awaitingPayoutsActiveTab, setAwaitingPayoutsActiveTab] = useState(1)
  const [paidPayoutsActiveTab, setPaidPayoutsActiveTab] = useState(1)
  const [curatorsActiveTab, setCuratorsActiveTab] = useState(1)
  const [modal, setModal] = useState(false)
  const [payout, setPayout] = useState({})
  const [isError, setIsError] = useState(false)
  const [isPaymentSuccessful, setIsPaymentSuccessful] = useState(false)
  const [
    isSubmitRecipientCheckingNeededSuccessfull,
    setIsSubmitRecipientCheckingNeededSuccessfull,
  ] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('Something went wrong.')
  const [selectedCuratorId, setSelectedCuratorId] = useState()
  const [selectedPayoutId, setSelectedPayoutId] = useState()
  const [infoModal, setInfoModal] = useState(false)
  const [confirmModal, setConfirmModal] = useState(false)
  const [cancelModal, setCancelModal] = useState(false)
  const [autopayoutOffModal, setAutopayoutOffModal] = useState(false)
  const [autopayOffId, setAutopayOffId] = useState()
  const [sortBy, setSortBy] = useState('date')
  const [searchValue, setSearchValue] = useState(' ')

  const toggle = tab => {
    // eslint-disable-next-line no-unused-expressions
    activeTab !== tab ? setActiveTab(tab) : null
  }
  const modalToggle = () => {
    setModal(!modal)
    setIsError(false)
    setIsLoading(false)
    setIsPaymentSuccessful(false)
    setIsSubmitRecipientCheckingNeededSuccessfull(false)
  }

  useEffect(() => {
    if (activeTab === '2') {
      getPaidPayouts(paidPayoutsActiveTab, searchValue, sortBy)
    }
  }, [sortBy])

  useEffect(() => {
    selectedCuratorId && dispatch(getSelectedCuratorStats(selectedCuratorId))
    selectedCuratorId && dispatch(getSelectedCurator(selectedCuratorId))
  }, [selectedCuratorId])

  const addingRate = useMemo(() => {
    if (!requestsReceivedCurrPeriod) return 0
    const value = parseFloat(
      ((addedToPlayListCurrPeriod / requestsReceivedCurrPeriod) * 100).toFixed(
        2
      )
    )
    if (isNaN(value) || value === 0.0) return 0
    return value
  }, [addedToPlayListCurrPeriod, requestsReceivedCurrPeriod])

  const handlePayoutConfirmation = payoutId => {
    setPayout(awaitingPayouts.find(({ id }) => id === payoutId))
    modalToggle()
  }

  const toggleCancelModal = () => {
    setCancelModal(!cancelModal)
  }

  const [handleCancelPayout] = useDebouncedCallback(() => {
    selectedPayoutId &&
      dispatch(
        cancelPayout(selectedPayoutId, () => {
          getAwaitingPayouts(awaitingPayoutsActiveTab)
          toggleCancelModal()
        })
      )
  }, 1000)

  const [debouncedGetPaidPayouts] = useDebouncedCallback(value => {
    getPaidPayouts(paidPayoutsActiveTab, value, sortBy)
  }, 1000)

  const [debouncedGetAwaitingPayouts] = useDebouncedCallback(value => {
    getAwaitingPayouts(paidPayoutsActiveTab, value)
  }, 1000)

  const [debouncedGetSearchedCurators] = useDebouncedCallback(value => {
    dispatch(getCurators(curatorsActiveTab, value))
  }, 1000)

  const handleSortAutopay = () => {
    sortBy !== 'AUTOPAY_DESC'
      ? setSortBy('AUTOPAY_DESC')
      : setSortBy('AUTOPAY_ASC')
  }

  const handlePayout = (curatorId, payoutId) => {
    setIsLoading(true)
    payoutToCurator(curatorId, payoutId, error => {
      if (error) {
        setErrorMessage(error.error.errors[0].message)
        setIsError(true)
        setIsLoading(false)
      } else {
        setIsPaymentSuccessful(true)
        setIsLoading(false)
        getAwaitingPayouts(awaitingPayoutsActiveTab)
        getPaidPayouts(paidPayoutsActiveTab)
      }
    })
  }

  const handleRecipientCheckingNeededSubmit = (curator_id, payout_id) => {
    setIsLoading(true)
    sendRecipientCheckingNeeded(curator_id, payout_id, error => {
      if (error) {
        setErrorMessage(JSON.stringify(error))
        setIsError(true)
        setIsLoading(false)
      } else {
        setIsError(false)
        setIsSubmitRecipientCheckingNeededSuccessfull(true)
        getPayouts()
        getAwaitingPayouts(awaitingPayoutsActiveTab)
        getPaidPayouts(paidPayoutsActiveTab)
        setIsLoading(false)
      }
    })
  }

  const handleCuratorChangeAutopay = (curator_id, autopay) => {
    if (autopay) {
      setAutopayoutOffModal(true)
      setAutopayOffId(curator_id)
      dispatch(getAutopayCurators(curatorsActiveTab))
    } else {
      dispatch(
        changeCuratorAutopay(curator_id, !autopay, () => {
          getAwaitingPayouts(awaitingPayoutsActiveTab)
          dispatch(getAutopayCurators(curatorsActiveTab))
        })
      )
    }
  }

  const handleCancelAutopay = () => {
    dispatch(
      changeCuratorAutopay(autopayOffId, false, () => {
        getAwaitingPayouts(awaitingPayoutsActiveTab)
        setAutopayoutOffModal(false)
        dispatch(getAutopayCurators(curatorsActiveTab))
      })
    )
  }

  const handleAutopayoutPage = page_number => {
    dispatch(getAutopayCurators(page_number))
  }

  const toggleInfoModal = () => {
    setInfoModal(!infoModal)
  }

  const toggleConfirmModal = () => {
    setConfirmModal(!confirmModal)
  }

  const toggleAutopayoutOffModal = () => {
    setAutopayoutOffModal(!autopayoutOffModal)
  }

  const handleFindPayouts = str => {
    setSearchValue(str)
    switch (activeTab) {
      case '1':
        debouncedGetAwaitingPayouts(str)
        break
      case '2':
        debouncedGetPaidPayouts(str)
        break
      case '3':
        debouncedGetSearchedCurators(str)
        break
      default:
        break
    }
  }

  return (
    <>
      <Modal
        fade={false}
        errorMessage={errorMessage}
        handleSubmit={handlePayout}
        isError={isError}
        handleRecipientCheckingNeededSubmit={
          handleRecipientCheckingNeededSubmit
        }
        isSubmitRecipientCheckingNeededSuccessfull={
          isSubmitRecipientCheckingNeededSuccessfull
        }
        isLoading={isLoading}
        isSubmitSuccessful={isPaymentSuccessful}
        item={payout}
        modal={modal}
        toggle={modalToggle}
        type="payout"
        handleCuratorChangeAutopay={handleCuratorChangeAutopay}
        awaitingPayouts={awaitingPayouts}
      />
      {selectedCuratorId && (
        <CuratorInfoModal
          addingRate={addingRate}
          curator={selectedCurator}
          modal={infoModal}
          toggle={toggleInfoModal}
          type="success"
          handleCuratorChangeAutopay={handleCuratorChangeAutopay}
        />
      )}

      <PayoutAutopayOffModal
        curator="test"
        modal={autopayoutOffModal}
        toggle={toggleAutopayoutOffModal}
        handleConfirmPress={handleCancelAutopay}
        type="success"
      />
      <PayoutCancelModal
        payoutId={selectedPayoutId}
        modal={cancelModal}
        toggle={toggleCancelModal}
        type="success"
        handleConfirmPress={handleCancelPayout}
      />
      <Row className="users-tab-row">
        <Col lg={6} md={6} xl={3} xs={12}>
          <CardBody className="balance-card">
            <div className="dashboard__booking-total-container">
              <h5 className="dashboard__booking-total-title dashboard__booking-total-title--red">
                {payoutCounters && payoutCounters.total_awaiting}
              </h5>
            </div>
            <h5 className="dashboard__booking-total-description">
              Total Payouts Requests Amounts
            </h5>
          </CardBody>
        </Col>
        <Col lg={6} md={6} xl={3} xs={12}>
          <CardBody className="balance-card">
            <div className="dashboard__booking-total-container">
              <h5 className="dashboard__booking-total-title dashboard__booking-total-title--red">
                {payoutCounters && payoutCounters.total_payouts}
              </h5>
            </div>
            <h5 className="dashboard__booking-total-description">
              Total Payouts Requests
            </h5>
          </CardBody>
        </Col>
        <Col lg={6} md={6} xl={3} xs={12}>
          <CardBody className="balance-card">
            <div className="dashboard__booking-total-container">
              <h5 className="dashboard__booking-total-title dashboard__booking-total-title--red">
                {payoutCounters && payoutCounters.total_paid}
              </h5>
            </div>
            <h5 className="dashboard__booking-total-description">
              Total Paid Out
            </h5>
          </CardBody>
        </Col>
        <Col lg={6} md={6} xl={3} xs={12}>
          <CardBody className="balance-card">
            <div className="dashboard__booking-total-container">
              <h5 className="dashboard__booking-total-title dashboard__booking-total-title--red">
                ${totalBalance}
              </h5>
            </div>
            <h5 className="dashboard__booking-total-description">
              Total Current Balances
            </h5>
          </CardBody>
        </Col>
      </Row>
      <Card className="tabs-wrapper">
        <div className="tabs tabs--bordered-bottom">
          <div className="tabs__wrap admin-tabs">
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === '1' })}
                  onClick={() => {
                    toggle('1')
                  }}
                >
                  {t('adminPage.payoutsPageAwaitingApproval')}{' '}
                  <CountInfo>
                    {payoutCounters && payoutCounters.awaitingPayouts}
                  </CountInfo>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === '2' })}
                  onClick={() => {
                    toggle('2')
                  }}
                >
                  Paid &ensp;
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === '3' })}
                  onClick={() => {
                    toggle('3')
                  }}
                >
                  Autopayout &ensp;
                </NavLink>
              </NavItem>
            </Nav>
            <span className="search-wrapper">
              <div className="inbox__emails-control-search">
                <input
                  placeholder="Search"
                  onChange={e => handleFindPayouts(e.target.value)}
                />
                <div className="inbox__emails-control-search-icon">
                  <MagnifyIcon />
                </div>
              </div>
            </span>
          </div>
        </div>
        <TabContent activeTab={activeTab}>
          {activeTab === '1' && (
            <TabPane tabId="1">
              <PayoutsTable
                handleLoginAs={handleLoginAs}
                handlePayoutConfirmation={handlePayoutConfirmation}
                getItems={getAwaitingPayouts}
                payouts={awaitingPayouts}
                payoutCounters={payoutCounters.awaitingPayouts}
                setActiveTab={setAwaitingPayoutsActiveTab}
                activeTab={activeTab}
                handleCancelPayout={handleCancelPayout}
                setSelectedPayoutId={setSelectedPayoutId}
                toggleCancelModal={toggleCancelModal}
                toggleConfirmModal={toggleConfirmModal}
                setSelectedCuratorId={setSelectedCuratorId}
                toggleInfoModal={toggleInfoModal}
              />
            </TabPane>
          )}
          {activeTab === '2' && (
            <TabPane tabId="2">
              <PayoutsTable
                handleLoginAs={handleLoginAs}
                handlePayoutConfirmation={handlePayoutConfirmation}
                getItems={getPaidPayouts}
                payouts={paidPayouts}
                payoutCounters={payoutCounters.paidPayouts}
                setActiveTab={setPaidPayoutsActiveTab}
                activeTab={activeTab}
                setSortBy={setSortBy}
                handleSortAutopay={handleSortAutopay}
                setSelectedCuratorId={setSelectedCuratorId}
                toggleInfoModal={toggleInfoModal}
              />
            </TabPane>
          )}
          {activeTab === '3' && (
            <TabPane tabId="3">
              <PayoutsTable
                payouts={autopayCurators}
                curators={autopayCurators}
                handleCuratorChangeAutopay={handleCuratorChangeAutopay}
                handleLoginAs={handleLoginAs}
                handlePayoutConfirmation={handlePayoutConfirmation}
                getItems={handleAutopayoutPage}
                payoutCounters={totalAutopayCurators}
                setActiveTab={setCuratorsActiveTab}
                activeTab={activeTab}
                setSelectedCuratorId={setSelectedCuratorId}
                toggleInfoModal={toggleInfoModal}
              />
            </TabPane>
          )}
        </TabContent>
      </Card>
    </>
  )
}

export default Users
